import {
  Box,
  Card,
  DELETE_WARNING,
  Grid,
  Stack,
  Typography,
  clickableStyle,
  getSpacing,
  newToast,
  useElementBreakpoints,
} from "@compass/core";
import { FilePanel } from "components";
import {
  ApplicationResponseFile,
  FileTypeCategory,
  Permission,
  PermissionAction,
  StudentApplicationEditResource,
} from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { fileDetailPageRoute } from "./FileDetail/FileDetailPage";
import { useRouter } from "hooks";
import { FileListItem } from "./FileList/FileListItem";
import { FileDetailTypeEnum } from "./FileDetail/FileDetailTypeEnum";

export const StudentApplicationFiles = (props: { initialLoad: boolean; applicationResponseId: number }) => {
  const ROOT_PERMISSION: Permission = Permission.StudentFile;
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [applicationFileResource, setApplicationFileResource] = useState<StudentApplicationEditResource>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();
  const [files, setFiles] = useState<ApplicationResponseFile[]>();

  let location = useLocation();

  const fetchList = () => {
    ApiService.studentApplications.getApplicationResponseFiles(props.applicationResponseId).then((response) => {
      setFiles(response);
    });

    ApiService.studentApplications.getFileEditResource()
      .then((response) => {
        setApplicationFileResource(response);
      });
  };

  useEffect(() => {
    if (!location.pathname.includes("dialog")) {
      fetchList();
    }
  }, [location]);

  useEffect(() => {
    if (props.initialLoad) {
      fetchList();
    }
  }, [props.initialLoad]);

  const renderFileItem = (file: ApplicationResponseFile, fileIndex: number) => {
    const matchedFileCategory = applicationFileResource?.fileCategories?.find(c => c.id == file.fileCategoryId);

    return (
      <FileListItem file={file} index={fileIndex} fileCategory={matchedFileCategory ? matchedFileCategory.name : undefined} />
    );
  };

  return (
    <>
      <Card header="Files">
        <Grid ref={breakpointsRef} container spacing="sm">
          {files?.map((file, fileIndex) => renderFileItem(file, fileIndex))}

          {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
            <Grid item xs={smallFieldBreakpoints}>
              <Box
                position="relative"
                p={getSpacing("sm")}
                overflow="hidden" // need this for ellipsis to work?
                sx={{
                  border: (theme) => `1px solid ${theme.palette.border.dark}`,
                  pointerEvents: "auto",
                  opacity: 1,
                }}
              >
                <Stack
                  position="relative"
                  direction="row"
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{ height: "42px", ...clickableStyle, opacity: "0.7" }}
                  onClick={() =>
                    navigate({
                      pathname: fileDetailPageRoute.getPath({
                        fileType: FileTypeCategory.Application,
                        screenType: "dialog",
                        crudMode: "edit",
                        parentEntityId: props.applicationResponseId,
                        entityId: 0,
                      }),
                    })
                  }
                >
                  <FileUploadRoundedIcon />
                  <Typography>Add File</Typography>
                </Stack>
              </Box>
            </Grid>
          )}
        </Grid>
      </Card>

      {matchTemplatePath(fileDetailPageRoute.templatePath) && <Outlet />}
    </>
  );
};
